module.exports = __webpack_public_path__ + "static/media/horse.8217ed3a.png";